// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI, { Alert, MessageBox } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';
import Commom from "./common/common";
import store from './vuex/store'


import Axios from 'axios'

import VueAwesomeSwiper from 'vue-awesome-swiper';

// require styles
import 'swiper/css/swiper.css'
import 'swiper/js/swiper.js'
import 'swiper/js/swiper.esm'




import router from './router'
import 'vue-social-share/dist/client.css';

import '@/assets/style/common.css';
import App from './App'

//分享
// import SocialSharing from 'vue-social-sharing'
// Vue.use(SocialSharing);
// 分享
import Share from 'vue-social-share';
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';


Vue.use(vuescroll);

import '../node_modules/social-share.js/dist/css/share.min.css';
import '../node_modules/social-share.js/dist/js/social-share.min.js'


Vue.use(Share)


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Commom);
Vue.use(store);
Vue.use(VueAwesomeSwiper);


// 五个标题的统计
Vue.prototype.counts = {
  pt: "",
  wl: "",
  ys: "",
  hz: ""
},
  Vue.config.devtools = true;


// 打包 时用这个
// Axios.defaults.baseURL = 'http://cty.cty001.com/api'; //给后台打包用这个 测试环境
// Axios.defaults.baseURL = 'http://zz.cty001.com/api'; //给后台打包用这个  生成环境
 Axios.defaults.baseURL = 'http://www.cty001.com/api'; //给后台打包用这个  生成环境
// Axios.defaults.baseURL = 'http://192.168.136.9/api'
// Axios.defaults.baseURL = 'http://192.168.31.140/api'
// Axios.defaults.baseURL = 'http://192.168.31.140/api'

// 本地 时用这个
//Axios.defaults.baseURL = '/api';   // 本地地址api

function generateDeviceId() {
  const deviceIdKey = 'device_id';
  let deviceId = localStorage.getItem(deviceIdKey);
  if (!deviceId) {
    deviceId = generateUUID();
    localStorage.setItem(deviceIdKey, deviceId);
  }
  return deviceId;
};
function generateUUID() {
  const buf = new Uint32Array(4);
  crypto.getRandomValues(buf);

  const S4 = function (num) {
    console.log(num)
    return (num + 0x10000).toString(16).substring(1);
  };
  return (
    S4(buf[0]) +
    S4(buf[1]) +
    '-' +
    S4(buf[2]) +
    '-' +
    S4(buf[3])
  );
}



Axios.defaults.headers.common['Authentication-Platform'] = 0;
Axios.defaults.headers.common['Authentication-DeviceId'] = generateDeviceId();
// Axios.defaults.headers.common['Authentication-Token'] = sessionStorage.getItem("token");
Axios.defaults.timeout = 50000;
Vue.prototype.$http = Axios;
router.beforeEach((to, from, next) => {
  window.scroll(0, 0);
  next();
})


// token 管理
let isRefreshing = false; // 是否正在刷新 token
let refreshSubscribers = []; // 等待中的请求队列

const getToken = () => sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null; // 获取 token
const setToken = (user) => {
  let userInfo = user;
  // sessionStorage.setItem('userInfo', JSON.stringify(userInfo)); // 设置 token
  sessionStorage.setItem('token', userInfo.token); // 设置 token
  store.commit('login', userInfo);
};

const getRefreshToken = () => sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).refreshToken : null; // 获取 refreshToken


// 刷新 token 的逻辑
function refreshToken() {
  return new Promise((resolve, reject) => {
    const refreshToken = getRefreshToken();
    Axios.post(`/user/refreshToken`, { refreshToken }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (response.data.code === 200) {
        resolve(response.data.data);
      } else if (response.data.code === 60009) {
        // 登录超时，提示用户重新登录
        sessionStorage.clear();
        MessageBox.alert('登录超时', '友情提示', {
          confirmButtonText: '重新登录',
          type: 'warning'
        }).then(() => {
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
          })
        });

        reject(new Error('登录超时，请重新登录'));
      } else if (response.data.code === 60001) {
        // 登录超时，提示用户重新登录
        sessionStorage.clear();
        MessageBox.alert('账号不存在或已删除', '友情提示', {
          confirmButtonText: '重新登录',
          type: 'warning'
        }).then(() => {
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
          })
        });

        reject(new Error('登录超时，请重新登录'));
      }
      else {
        reject(new Error('刷新 token 失败'));
      }
    }).catch(error => {
      reject(error);
    });
  });
}


// 请求拦截器
Axios.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers['Authentication-Token'] = token;
    }
    config.headers['Authentication-DeviceId'] = generateDeviceId();
    config.headers['Authentication-Platform'] = 0;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


// 响应拦截器
Axios.interceptors.response.use(
  async response => {
    const { data } = response;
    if (data.code === 60009) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {

          const user = await refreshToken();
          const newToken = user.token;
          setToken(user);

          // 通知等待中的请求
          refreshSubscribers.forEach(callback => callback(newToken));
          refreshSubscribers = [];

          isRefreshing = false;

          // 重发原请求
          response.config.headers['Authentication-Token'] = newToken;
          return Axios(response.config);
        } catch (err) {
          // 刷新失败，清空队列并跳转到登录
          isRefreshing = false;
          refreshSubscribers = [];
          MessageBox.alert('登录超时', '友情提示', {
            confirmButtonText: '重新登录',
            type: 'warning'
          }).then(() => {
            router.replace({
              path: '/login',
              query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
            })
          });
          return Promise.reject(err);
        }
      } else {
        // 正在刷新 token，将请求加入队列
        return new Promise(resolve => {
          refreshSubscribers.push(newToken => {
            response.config.headers['Authentication-Token'] = newToken;
            resolve(Axios(response.config));
          });
        });
      }
    } else if (data.code === 60010) {
      sessionStorage.clear();
      MessageBox.alert('您的账号在其他设备上登录，请重新登录', '友情提示', {
        confirmButtonText: '重新登录',
        type: 'warning'
      }).then(() => {
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
        })
      });
    } else {
      // 正常返回
      return response;
    }
  },
  error => {
    return Promise.reject(error);
  }
);





















































// // 添加请求拦截器
// Axios.interceptors.request.use(config => {
//   // console.log(config,'hhhhhh')
//   // 在发送请求之前做些什么

//   if (sessionStorage.getItem("token")) {
//     config.headers.common['Authentication-Token'] = sessionStorage.getItem("token");
//   }
//   return config;


//   // if (ctyy&&config.url !="/user/refreshToken"){
//   //   //暂停所有请求
//   //   console.log("ctyy1111111")
//   // }else{
//   //   console.log("ctyy22222")
//   //   //恢复

//   //   return config;
//   // }


// }, error => {
//   // 对请求错误做些什么
//   return Promise.reject(error);
// });



// let isProcessingRefreshToken = false; // 新增一个变量用于标记是否正在走60009
// // http response 拦截器
// Axios.interceptors.response.use(
//   async response => {
//     let urlFlag = false;
//     if (response.config.url == "/user/refreshToken") {
//       urlFlag = true;//排除获取token接口拦截
//     }
//     console.log("333333333333333")
//     console.log(response.data.code == 60009 && !urlFlag && !hasHandledRefreshToken && !
//       isProcessingRefreshToken, "88888888888888888")
//     const hasHandledRefreshToken = sessionStorage.getItem('hasHandledRefreshToken');
//     if (response.data.code == 60009 && !urlFlag && !hasHandledRefreshToken && !
//       isProcessingRefreshToken) {
//       isProcessingRefreshToken = true; // 设置为正在处理
//       sessionStorage.setItem('hasHandledRefreshToken', '123');
//       console.log("2222222222222222222")
//       try {
//         // 从 localStorage 中获取 userInfo.refreshToken
//         let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
//         const refreshToken = userInfo ? userInfo.refreshToken : null;
//         if (refreshToken) {
//           try {
//             // 发起 POST 请求到 /user/refreshToken 接口，并传递 refreshToken 参数
//             await Axios.post('/user/refreshToken', { refreshToken }).then((res) => {
//               if (res.data.code == 60009) {
//                 sessionStorage.removeItem("hasHandledRefreshToken");
//                 isProcessingRefreshToken = false; // 处理完成后重置标记
//                 MessageBox.alert('登录超时', '友情提示', {
//                   confirmButtonText: '重新登录',
//                   type: 'warning'
//                 }).then(() => {
//                   router.replace({
//                     path: '/login',
//                     query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
//                   })
//                 });
//               }else if (res.data.code == 200) {
//                 sessionStorage.removeItem("hasHandledRefreshToken");
//                 isProcessingRefreshToken = false; // 处理完成后重置标记
//                 const newToken = res.data.data.token;
//                 // console.log(newToken,'123');
//                 // 更新 localStorage 中的 token 信息
//                 userInfo.token = newToken;
//                 sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
//                 sessionStorage.setItem('token', newToken);
//                 sessionStorage.removeItem('hasHandledRefreshToken22');
//                 // 更新后续请求的 tokenF
//                 Axios.defaults.headers.common['Authentication-Token'] = newToken;
//                 location.reload();
//                 // // 获取原始请求的配置
//                 // const originalRequest = response.config;
//                 // originalRequest.headers['Authentication-Token'] = newToken;
//                 // // 重新发送原始请求
//                 // Axios(originalRequest)
//               } else {
//                 console.log("111111111111111");
//               }
//             })
//           } catch (error) {
//             console.error('Failed to refresh token:', error);
//             // 可根据实际情况进行处理，如重定向到登录页面
//             // router.push('/login');
//             return Promise.reject(error);
//           } finally {
//             // sessionStorage.removeItem("hasHandledRefreshToken");
//           }
//           console.log("==============");

//         } else {
//           sessionStorage.removeItem("hasHandledRefreshToken");
//         }
//       } catch (error) {
//         console.error('Failed to refresh token:', error);
//         // 可根据实际情况进行处理，如重定向到登录页面
//         // router.push('/login');
//         return Promise.reject(error);
//       } finally {
//         // sessionStorage.removeItem("hasHandledRefreshToken");
//       }
//     } else {
//       return response;
//     }
//   },
//   error => {
//     if (error.response) {
//       switch (error.response.status) {
//         case 401:
//           this.$store.commit('del_token');
//           router.replace({
//             path: '/login',
//             query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
//           })
//       }
//     }
//     return Promise.reject(error.response.data)
//   });










/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js